import { Box, Button, Text } from '@chakra-ui/react';
import { Col, Row } from 'antd';
import cn from 'classnames';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import Styles from '../SellYourCarForm.module.scss';

interface VehicleDetailsStepProps {
  control: Control<any>;
  errors: FieldErrors<any>;
  options: string[];
  name: string;
  errorMessage: string;
  colSize: number;
}

const VehicleDetailsStep: React.FC<VehicleDetailsStepProps> = ({
  control,
  errors,
  options,
  name,
  errorMessage,
  colSize,
}) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{ required: errorMessage }}
        render={({ field }) => (
          <Box>
            <Row gutter={6}>
              {options.map((option) => (
                <Col sm={colSize} style={{ width: '100%' }} key={option}>
                  <Button
                    mb={{ sm: '18px' }}
                    w="full"
                    variant={'solid'}
                    onClick={() => field.onChange(option)}
                    className={cn(Styles.optionButton, {
                      [Styles.selected as string]: field.value === option,
                    })}
                  >
                    {option}
                  </Button>
                </Col>
              ))}
            </Row>
          </Box>
        )}
      />
      {errors[name] && (
        <Text color="red.500" fontSize="sm">
          {errors[name]?.message?.toString() || errorMessage}
        </Text>
      )}
    </>
  );
};

export default VehicleDetailsStep;
